import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { fetchFacebookPages } from './api';

/**
 * Get config
 */
export const useQueryFacebookPages = () => {
    return useQuery({
        queryKey: QUERY_KEYS.facebookPages(),
        queryFn: fetchFacebookPages,
    });
};
